const BASE_URL = 'https://media.centsdonations.com/img'

export function getCharityLogoUrl(charityId: string): string {
  return `${BASE_URL}/charities/${charityId}/logo.png`
}